import { render, staticRenderFns } from "./AccountTransactionValueLabel.vue?vue&type=template&id=80159300"
import script from "./AccountTransactionValueLabel.vue?vue&type=script&lang=js"
export * from "./AccountTransactionValueLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports